<div class="container-fluid p-0" style="height: calc(100vh - 56px);">
  <div class="row m-0 p-0">
    <div [ngClass]="{'col-sm-8 pr-0 pl-0' : flagListMember, 'col-sm-12 p-0': !flagListMember}">
      <div class="ml-0 mr-0 mt-2 float-left row w-100 align-items-center">
        <div class="col-sm-8 d-inline-flex p-0">
          <div class="group-list-image ml-2">
            <div *ngIf="roomName?.members.length <= 4" class="text-sm-center">
              <div class="row m-0 p-0 justify-content-center">
                <div *ngFor="let member of roomName.members" class="col-sm-6 p-0">
                  <img class="contact-image-list mt-1" userAvatar [usercode]="member?.username"
                       [title]="member?.fullname">
                </div>
              </div>
            </div>
            <div *ngIf="roomName?.members.length > 4">
              <div class="row m-0 p-0 justify-content-center">
                <div *ngFor="let member of roomName.members.slice(0, 3)" class="mt-1 col-sm-6 m-0 p-0 ">
                  <!--        <div class="contact-online" [ngClass]="{'online': member?.joined,'offline': !member?.joined }">-->
                  <img class="contact-image-list" userAvatar [usercode]="member?.username" [title]="member?.fullname">
                  <!--        </div>-->
                </div>
                <div class="col-sm-6 p-0 ">
                  <div class="contact-plus ml-1 mt-1"
                       [title]="showNameMemberInGroup(roomName.members.slice(3, roomName.members.length))"
                       [innerHTML]="'+' + roomName.members.slice(3, roomName.members.length).length">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="contact-messenger-content ml-3 mt-2">
            <div [title]="roomName?.subject.length > 80 ? roomName?.subject : '' "
                 class="contact-messenger-name text-truncate font-size-title font-weight-bold">{{nameRoomShort(roomName?.subject, 70)}}</div>
            <div class="contact-messenger-detail font-size-content">{{roomName?.members.length}} Thành viên</div>
          </div>
        </div>
        <div class="col-sm-4  p-0">
          <i class="message-chat__action fa fa-list float-right"
             [ngStyle]="flagListMember ? {'color': '#007bff'} : {'':''}" (click)="showListMemberRoom()"
             aria-hidden="true" title="List Member Room Chat"></i>
          <i class="message-chat__action img-info-list-group float-right"
             aria-hidden="true" title="Detail Room Chat"></i>
          <i *ngIf="username == roomName.creator && !flagHiddenAction"
             class="message-chat__action fa fa-trash float-right"
             aria-hidden="true" title="Delete" (click)="showModal()"></i>
          <div class="message-chat__action img-edit-list-group float-right" title="Add member"
               (click)="callAddMemberToGroup()"></div>
          <i *ngIf="checkPhone && !flagHiddenAction" class="message-chat__action float-right fa fa-phone " title="Phone"
             (click)="joinRoom(roomName?.conferenceID); hiddenAction()"></i>
        </div>
      </div>
    </div>
    <div *ngIf="flagListMember" class="col-sm-4 bg-linear text-center border-left pl-0">
      <div class="mt-4 text-center font-size-title font-weight-bold">Thông tin nhóm</div>
    </div>
  </div>
  <div class="row m-0 form-group h-100 ">
    <div [ngClass]="{'col-sm-8 pr-0 pl-0' : flagListMember, 'col-sm-12 p-0': !flagListMember}">
      <div class="message-video">
        <div id="meetRoom" class="container-video-meet" [ngClass]="{'hide': videoPanelVisible}"></div>
      </div>
      <div class="col-sm-12 mt-3 d-inline-block border-top">
        <div class="mt-1 img-list-group float-left"></div>
        <div class="mt-3 ml-5 font-weight-bold font-size-title">Danh sách thành viên</div>
      </div>
      <div class="col-sm-12 border-top mt-2  messenger-call-list">
        <div class="col-sm-6 d-inline-block float-left mt-4" *ngFor="let member of listRoom">
          <div class="d-flex">
            <div class="group-leader"
                 [ngClass]="{'online': getUserCodeMember(member)}"
                 [title]="getUserCodeMember(member) ? 'Creator' : ''">
              <img class="messenger-contract-img" [title]="member.fullname" userAvatar
                   [usercode]="member.username ? member.username : ''">
            </div>
            <!--            <div class="messenger-contact-name mt-3">-->
            <div [title]="member.fullname"
                 class="font-weight-bold ml-3 mt-3 d-inline font-size-content text-truncate font-weight-bold short-content">
              {{member.fullname !== '' ? member.fullname : member.username}}</div>
            <!--              <div class="contact-detail ml-3 mt-1" *ngIf="member.isJoined">Đã tham gia</div>-->
            <!--              <div class="contact-detail ml-3 mt-1" *ngIf="!member.isJoined && !member.isLeft">Chưa tham gia</div>-->
            <!--              <div class="contact-detail ml-3 mt-1" *ngIf="member.isLeft">Đã rời khỏi phòng</div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="flagListMember" class="col-sm-4 pl-0 border-left bg-linear" style="calc(100vh - 132px);">
      <!--      <div #listBody class="h-75">-->
      <div class="mb-2">
        <div class="group-list-image">
          <!--  <div class="contact-image-group">-->
          <div *ngIf="roomName?.members.length <= 4" class="text-sm-center">
            <div *ngFor="let member of roomName.members" class="mt-1 d-inline-block">
              <!--        <div class="contact-online" [ngClass]="{'online': member?.joined,'offline': !member?.joined }">-->
              <img class="contact-image-list" userAvatar [usercode]="member?.username" [title]="member?.fullname">
              <!--        </div>-->
            </div>
          </div>
          <div *ngIf="roomName?.members.length > 4">
            <div *ngFor="let member of roomName.members.slice(0, 3)" class="mt-1 d-inline-block">
              <!--        <div class="contact-online" [ngClass]="{'online': member?.joined,'offline': !member?.joined }">-->
              <img class="contact-image-list" userAvatar [usercode]="member?.username" [title]="member?.fullname">
              <!--        </div>-->
            </div>
            <div class="contact-plus"
                 [title]="showNameMemberInGroup(roomName.members.slice(3, roomName.members.length))"
                 [innerHTML]="'+' + roomName.members.slice(3, roomName.members.length).length">
            </div>
          </div>
        </div>
        <div class="text-center mt-2">
          <div [title]="roomName?.subject"
               class="contact-messenger-name ml-2 text-truncate font-weight-bold font-size-title">{{roomName?.subject}}</div>
          <div class="font-size-content mt-1" [innerHTML]="roomName?.members.length + ' thành viên'"></div>
        </div>
      </div>
      <div (click)="hiddenMemberGroup()" class="d-inline-flex">
        <div class="btn font-size-title font-weight-bold">Danh sách thành viên:</div>
        <i class="fa fa-2x ml-3 " aria-hidden="true"
           [ngClass]="{'fa-sort-desc': flagHiddenListMember, 'fa-sort-asc mt-2': !flagHiddenListMember}"></i>
      </div>
      <div *ngIf="flagHiddenListMember">
        <div class="messenger-body-list col-sm-12 ml-sm-0 pl-sm-0">
          <div *ngFor="let member of listRoom">
            <div class="d-flex">
              <!--              <div [title]="member.isJoined ? 'Đã tham gia' : member.isLeft ? 'Đã thoát' : !member.isJoined && !member.isLeft ? 'Chưa tham gia' : ''"-->
              <!--                [ngClass]="{'isJoin': member.isJoined, 'unJoin': !member.isJoined && !member.isLeft, 'isLeft': member.isLeft, 'member-group-join-call': !getUserCodeMember(member)}">-->
              <div class="leader-group"
                   [ngClass]="{'leader':getUserCodeMember(member)}"
                   [title]="getUserCodeMember(member) ? 'Creator' : ''">
                <img class="messenger-contract-img mt-2" userAvatar [title]="member.fullname"
                     [usercode]="member.username ? member.username : ''">
              </div>
              <!--              </div>-->

              <div [title]="member.fullname"
                   class="mt-4 ml-2 d-inline font-size-content text-truncate font-weight-bold short-content">
                {{member.fullname !== '' ? member.fullname : member.username}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      </div>-->
    </div>
  </div>
</div>

<!--<div class="messenger-footer">-->
<!--  <file-list #fileList fileList [fileEl]="fileEl" [files]="files"></file-list>-->
<!--  <div class="messenger-footer-inner">-->
<!--    <div class="messenger-footer-input">-->
<!--      <textarea type="text" #input autosize (keyup.enter)="sendMessage()" placeholder="Nhập nội dung ..."></textarea>-->
<!--    </div>-->
<!--    <label class="message-chat__action fa fa-image" style="margin-bottom: 0;">-->
<!--      <input #fileEl type="file" (change)="input.focus()" multiple style="display:none">-->
<!--    </label>-->
<!--    <i *ngIf="canSend" (click)="sendMessage()" class="messenger-footer-send message-chat__action fa fa-arrow-right"-->
<!--       aria-hidden="true"></i>-->
<!--  </div>-->
<!--</div>-->

<app-confirm-dialog iconCls="fa fa-trash" [title]="'Delete'"
                    [content]="'Do you sure want to delete this Group?'"></app-confirm-dialog>


<!--<div class="group-list-image">-->
<!--  <div *ngIf="roomName?.members.length <= 4" class="text-sm-center">-->
<!--    <div class="row m-0 p-0">-->
<!--      <div *ngFor="let member of roomName.members">-->
<!--        <div class="col-sm-6 m-0 p-0">-->
<!--          <img class="contact-image-list mt-1" userAvatar [usercode]="member?.username" [title]="member?.fullname">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div *ngIf="roomName?.members.length > 4">-->
<!--    <div class="row m-0 p-0">-->
<!--      <div *ngFor="let member of roomName.members.slice(0, 3)" class="mt-1 col-sm-6 m-0 p-0 ">-->
<!--        &lt;!&ndash;        <div class="contact-online" [ngClass]="{'online': member?.joined,'offline': !member?.joined }">&ndash;&gt;-->
<!--        <img class="contact-image-list" userAvatar [usercode]="member?.username" [title]="member?.fullname">-->
<!--        &lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->
<!--      <div class="col-sm-6 m-0 p-0">-->
<!--        <div class="contact-plus ml-1 mt-1"-->
<!--             [title]="showNameMemberInGroup(roomName.members.slice(3, roomName.members.length))"-->
<!--             [innerHTML]="'+' + roomName.members.slice(3, roomName.members.length).length">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<!--<div class="container-fluid"></div>-->
